export default __webpack_public_path__ + "d65ffd03cde0272d9e0f912883b473f5.png";